import trophyPerfect from "@assets/images/trophy_perfect.png";
import trophyGood from "@assets/images/trophy_good.png";
import trophyNormal from "@assets/images/trophy_normal.png";
import trophyBad from "@assets/images/trophy_bad.png";

import healthPartHeart from "@assets/images/icon_heart.png";
import healthPartPancreas from "@assets/images/icon_pancreas.png";
import healthPartVessel from "@assets/images/icon_vessel.png";
import healthPartLiver from "@assets/images/icon_liver.png";
import healthPartKidney from "@assets/images/icon_kidney.png";
import healthPartFat from "@assets/images/icon_fat.png";

import healthAgeHeart from "@assets/images/healthage_heart.png";
import healthAgePancreas from "@assets/images/healthage_pancreas.png";
import healthAgeVessel from "@assets/images/healthage_vessel.png";
import healthAgeLiver from "@assets/images/healthage_liver.png";
import healthAgeKidney from "@assets/images/healthage_kidney.png";
import healthAgeFat from "@assets/images/healthage_fat.png";

import authIconNaver from "@assets/images/icon_naver.png";
import authIconNaverLarge from "@assets/images/icon_naver_large.png";
import authIconKakao from "@assets/images/icon_kakao.png";
import authIconKakaoLarge from "@assets/images/icon_kakao_large.png";
import authIconPass from "@assets/images/icon_pass.png";
import authIconPassLarge from "@assets/images/icon_pass_large.png";
import { AuthTemplateProps } from "@components/templates/AuthTemplate";

export const ApiUrls = {
  prefix: "api/",
  data: {
    startAuth: "data/start_auth",
    afterAuth: "data/after_auth",
  },
};

export enum NationalDataAuthType {
  Naver = 1,
  Kakao,
  Pass = 80,
}

export const NationalDataAuthTypeKRStr = {
  [NationalDataAuthType.Naver]: "네이버",
  [NationalDataAuthType.Kakao]: "카카오",
  [NationalDataAuthType.Pass]: "PASS",
};

export const AuthTutorialLink = {
  [NationalDataAuthType.Naver]:
    "https://help.naver.com/service/22027/contents/10263?lang=ko",
  [NationalDataAuthType.Kakao]: "https://talktips.kakao.com/content/48",
  [NationalDataAuthType.Pass]: "https://www.passauth.co.kr/guide",
};

export const NationalDataAuthTypeIcon = {
  Small: {
    [NationalDataAuthType.Naver]: authIconNaver,
    [NationalDataAuthType.Kakao]: authIconKakao,
    [NationalDataAuthType.Pass]: authIconPass,
  },
  Large: {
    [NationalDataAuthType.Naver]: authIconNaverLarge,
    [NationalDataAuthType.Kakao]: authIconKakaoLarge,
    [NationalDataAuthType.Pass]: authIconPassLarge,
  },
};

export const AuthPageProps: Record<NationalDataAuthType, AuthTemplateProps> = {
  [NationalDataAuthType.Naver]: {
    icon: NationalDataAuthTypeIcon.Large[NationalDataAuthType.Naver],
    title: `네이버 앱 간편인증을\n진행해주세요`,
    authSteps: [
      {
        title: "네이버 앱에서 인증요청 메시지 확인",
      },
      {
        title: "인증진행",
        sub: "비밀번호, 생체인식 등",
      },
      {
        title: "인증 완료 후 아래 ‘인증 완료’ 선택",
      },
    ],
    pathStr: "[네이버 앱 실행 → ‘종 아이콘' → 네이버 인증서]",
    helpStrs: [
      "네이버 앱이 설치돼있는지, 알림 수신동의 되어 있는지 확인해주세요.",
    ],
  },
  [NationalDataAuthType.Kakao]: {
    icon: NationalDataAuthTypeIcon.Large[NationalDataAuthType.Kakao],
    title: `카카오 지갑 간편인증을\n진행해주세요`,
    authSteps: [
      {
        title: "카카오톡 앱에서 인증요청 메시지 확인",
      },
      {
        title: "인증진행",
        sub: "비밀번호, 생체인식 등",
      },
      {
        title: "인증 완료 후 아래 ‘인증 완료’ 선택",
      },
    ],
    pathStr: "[카카오톡 앱 실행 → 대화 → 카카오톡 지갑]",
  },
  [NationalDataAuthType.Pass]: {
    icon: NationalDataAuthTypeIcon.Large[NationalDataAuthType.Pass],
    title: `PASS 간편인증을\n진행해주세요`,
    authSteps: [
      {
        title: "PASS 앱에서 인증요청 메시지 확인",
      },
      {
        title: "인증진행",
        sub: "비밀번호, 생체인식 등",
      },
      {
        title: "인증 완료 후 아래 ‘인증 완료’ 선택",
      },
    ],
    pathStr: "[PASS 앱 실행 → 상단 인증 요청 알림]",
  },
};

export const GradeBGColor: Record<HealthGrade, string> = {
  최우수: "#06D0AC",
  우수: "#3E6EEA",
  보통: "#EDB72B",
  미흡: "#EB6363",
};

export const GradeTextColor: Record<HealthGrade, string> = {
  최우수: "#1C8BED",
  우수: "#06D0AC",
  보통: "#EBB00E",
  미흡: "#ED1C4D",
};

export const GradeTrophyIcon: Record<HealthGrade, any> = {
  최우수: trophyPerfect,
  우수: trophyGood,
  보통: trophyNormal,
  미흡: trophyBad,
};

export const HealthPartIcon: Record<HealthPart, any> = {
  심장: healthPartHeart,
  췌장: healthPartPancreas,
  혈관: healthPartVessel,
  간: healthPartLiver,
  신장: healthPartKidney,
  비만: healthPartFat,
};

export const HealthAgeIcon: Record<HealthPart, any> = {
  심장: healthAgeHeart,
  췌장: healthAgePancreas,
  혈관: healthAgeVessel,
  간: healthAgeLiver,
  신장: healthAgeKidney,
  비만: healthAgeFat,
};
